import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin-top: 1rem;
`;

const Header = styled.div`
  margin-bottom: 1.5rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  input {
    accent-color: #0077cc;
  }
`;

const CidadeBloco = styled.div`
  margin-bottom: 1rem;
`;

const CidadeHeader = styled.div`
  background-color: #f0f4fa;
  padding: 0.6rem 1rem;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  input {
    accent-color: #0077cc;
    pointer-events: auto;
  }
`;

const EmpreendimentosLista = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.6rem 1.5rem;
`;

const CheckboxLabel = styled.label`
  background-color: #f9fbff;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.95rem;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;

  input {
    accent-color: #0077cc;
  }

  &:hover {
    border: 1px solid #0077cc;
    background-color: #e8f3ff;
  }
`;


interface Empreendimento {
  id: number;
  nome: string;
  CidadeTable: {
    nome: string;
    EstadoTab: {
      abreviacao: string;
    };
  };
}

interface Props {
  empreendimentos: Empreendimento[];
  onChange: (selecionados: number[]) => void;
}

const AccordionEmpreendimentos = ({ empreendimentos, onChange }: Props) => {
  const [selecionados, setSelecionados] = useState<number[]>([]);
  const [cidadesAbertas, setCidadesAbertas] = useState<string[]>([]);

  const agrupados = empreendimentos.reduce((acc, emp) => {
    const cidade = emp.CidadeTable.nome;
    const estado = emp.CidadeTable.EstadoTab.abreviacao;
    const chave = `${cidade} - ${estado}`;
    if (!acc[chave]) acc[chave] = [];
    acc[chave].push(emp);
    return acc;
  }, {} as Record<string, Empreendimento[]>);

  const toggleEmpreendimento = (id: number) => {
    setSelecionados((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const toggleCidadeAberta = (cidade: string) => {
    setCidadesAbertas((prev) =>
      prev.includes(cidade) ? prev.filter((c) => c !== cidade) : [...prev, cidade]
    );
  };

  const marcarCidade = (cidade: string, marcar: boolean) => {
    const idsDaCidade = agrupados[cidade].map((e) => e.id);
    setSelecionados((prev) => {
      if (marcar) {
        return Array.from(new Set([...prev, ...idsDaCidade]));
      } else {
        return prev.filter((id) => !idsDaCidade.includes(id));
      }
    });
  };

  const marcarTodos = () => {
    if (selecionados.length === empreendimentos.length) {
      setSelecionados([]);
    } else {
      const todos = empreendimentos.map((e) => e.id);
      setSelecionados(todos);
    }
  };

  useEffect(() => {
    onChange(selecionados);
  }, [selecionados]);

  return (
    <Wrapper>
      <Header>
        <input
          type="checkbox"
          checked={selecionados.length === empreendimentos.length}
          onChange={marcarTodos}
        />
        <strong>Marcar todos os empreendimentos</strong>
      </Header>

      {Object.entries(agrupados).map(([cidade, lista]) => {
        const todosSelecionados = lista.every((e) => selecionados.includes(e.id));
        const algunsSelecionados = lista.some((e) => selecionados.includes(e.id));
        const expandido = cidadesAbertas.includes(cidade);

        return (
          <CidadeBloco key={cidade}>
            <CidadeHeader onClick={() => toggleCidadeAberta(cidade)}>
              <input
                type="checkbox"
                checked={todosSelecionados}
                onChange={(e) => marcarCidade(cidade, e.target.checked)}
              />
              <span>{expandido ? "▼" : "▶"} {cidade}</span>
            </CidadeHeader>

            {expandido && (
              <EmpreendimentosLista>
                {lista.map((emp) => (
                  <CheckboxLabel key={emp.id}>
                    <input
                      type="checkbox"
                      checked={selecionados.includes(emp.id)}
                      onChange={() => toggleEmpreendimento(emp.id)}
                    />
                    {emp.nome}
                  </CheckboxLabel>
                ))}
              </EmpreendimentosLista>
            )}
          </CidadeBloco>
        );
      })}
    </Wrapper>
  );
};

export default AccordionEmpreendimentos;
